import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_SEO, PROFILE_SAME_AS, ROUTE_SEO, SITE_URL } from "../seoConfig";

const setMeta = (selector, attribute, value) => {
  const tag = document.head.querySelector(selector);
  if (tag) {
    tag.setAttribute(attribute, value);
  }
};

const SEOHead = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = ROUTE_SEO[pathname] || DEFAULT_SEO;
    const url = seo.canonical || `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    const ogTitle = seo.ogTitle || seo.title;
    const ogDescription = seo.ogDescription || seo.description;
    const robots = pathname.startsWith("/admin") ? "noindex, nofollow" : "index, follow";

    document.title = seo.title;
    setMeta('meta[name="description"]', "content", seo.description);
    setMeta('meta[name="robots"]', "content", robots);
    setMeta('meta[property="og:title"]', "content", ogTitle);
    setMeta('meta[property="og:description"]', "content", ogDescription);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", ogTitle);
    setMeta('meta[name="twitter:description"]', "content", ogDescription);

    if (seo.image) {
      setMeta('meta[property="og:image"]', "content", seo.image);
      setMeta('meta[name="twitter:image"]', "content", seo.image);
    }

    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", url);
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Mai El Mokadem",
      url: SITE_URL,
      jobTitle: "Writer & Journalist",
      description: DEFAULT_SEO.description,
      sameAs: PROFILE_SAME_AS,
      knowsAbout: [
        "Fashion journalism",
        "Music journalism",
        "Cultural commentary",
        "Celebrity interviews",
        "Middle East creative culture",
      ],
    };

    let schemaTag = document.head.querySelector("#person-schema");
    if (!schemaTag) {
      schemaTag = document.createElement("script");
      schemaTag.id = "person-schema";
      schemaTag.type = "application/ld+json";
      document.head.appendChild(schemaTag);
    }
    schemaTag.textContent = JSON.stringify(schema);
  }, [pathname]);

  return null;
};

export default SEOHead;
